module.exports = __webpack_public_path__ + "img/edit.2ff1ecec.svg";